<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>卸料平台设备</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <span style="margin-left:20px">设备序列号：</span>
            <el-input style="margin-right:20px" placeholder="请输入设备序列号" v-model="dtuImei"></el-input>
            <el-button style="margin-right:20px" type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
            <el-button type="primary" @click="addRow()">绑定卸料平台设备</el-button>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" height="100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}"> 
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号">
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
               <el-table-column label="设备名称">
                <template slot-scope="scope">
                  <a>{{ scope.row.unloadName}}</a>
                </template>
              </el-table-column>
              <el-table-column label="设备号">
                <template slot-scope="scope">
                  <a>{{ scope.row.verifyCode}}</a>
                </template>
              </el-table-column>
              <el-table-column label="预警重量">
                <template slot-scope="scope">
                  <a>{{ scope.row.earlyWarningWeight}}</a>
                </template>
              </el-table-column>
              <el-table-column label="报警重量">
                <template slot-scope="scope">
                  <a>{{ scope.row.alarmWeight}}</a>
                </template>
              </el-table-column>
              <el-table-column label="所属项目">
                <template slot-scope="scope">
                  <span>{{ scope.row.projectName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="厂家">
                <template slot-scope="scope">
                  <span v-if="scope.row.equipType=='1'">携稳</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button>
                  <el-button size="mini" @click="toHistory(scope.row)">日志记录</el-button>
                </template>
              </el-table-column>

              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
                width="30%"
              >
                <el-form
                  :model="addForm"
                  ref="addForm"
                  label-width="150px"
                  :label-position="labelPosition"
                >
                  <!-- <el-form-item label="设备名称：">
                    <el-input style="width:220px"  v-model="addForm.name" autocomplete="off"></el-input>
                  </el-form-item> -->
                  <el-form-item label="设备号:">
                    <el-input style="width:220px" v-model="addForm.verifyCode" placeholder="请输入序列号" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="设备厂家:">
                    <el-select
                        v-model="addForm.equipType"
                        clearable
                        filterable
                        placeholder="请选择状态"
                        class="select"
                        style="width:220px"
                        >
                        <el-option  v-for="item in equipTypes" :key="item.value" :label="item.name" :value="item.value"></el-option>
                     </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[ 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      equipTypes: [
        { name: '携稳', value: '1' },
      ], // 类型下拉菜单组
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
         verifyCode:'', //imei序列号
         projectId:'',  //项目id
         equipType:'',  //厂家
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      dtuImei:''
    }
  },
  watch: {
    groupId: {
      handler(newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getList()
    },
    // 监控当前页码
    currentChangePage() {
      this.getList()
    },

    //获取列表
    getList() {
      var option = {
        projectId: this.groupId,
        pageSize:this.pageSize,
        pageNum:this.currentPage,
        verifyCode:this.dtuImei
      }
      var that = this
      myHttp.equipmentList(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total||0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      // this.dialogTitle = '编辑设备信息'
      // this.addFormVisible = true
      // this.addForm={
      //   name:row.name,
      //   id:row.id,
      //   configurationId:row.configurationId,
      //   dtuImei:row.dtuImei,
      //   groupId:this.groupId
      // }
    },

    // 删除数据 111
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteEquipment({
            platformId: row.platformId,
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },

    /**
     * 跳转日志列表
     */
    toHistory(row){
      this.$router.push({path:'/platformList/'+row.platformId})
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '卸料设备绑定'
      this.addFormVisible = true
      this.addForm = {
         verifyCode:'',
         projectId:'',
         equipType:'1',
      }
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '' || !that.addForm.id) {
           that.addForm.projectId = that.groupId
           that.addForm.createBy =util.session.get('user').id
            //添加
            myHttp.addEquipment(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改 1111
           that.addForm.updateBy=util.session.get('user').id
            // myHttp.updateTsDtu(that.addForm).then(
            //   function(resp) {
            //     if (resp.data.code == '200') {
            //       that.$message.success('修改成功')
            //       that.addFormVisible = false
            //       that.getList()
            //     } else {
            //       that.$message.error(resp.data.msg)
            //     }
            //   },
            //   function() {}
            // )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    doFilter(){
      this.getList()
    }
  }
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  /* justify-content: flex-end; */
  align-items: center;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  /* display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; */
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
</style>